var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeleconsultationChats(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20777_56193",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20777_56193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.83073 16.6668C3.3724 16.6668 2.98003 16.5036 2.65365 16.1772C2.32726 15.8509 2.16406 15.4585 2.16406 15.0002V5.00016C2.16406 4.54183 2.32726 4.14947 2.65365 3.82308C2.98003 3.49669 3.3724 3.3335 3.83073 3.3335H13.8307C14.2891 3.3335 14.6814 3.49669 15.0078 3.82308C15.3342 4.14947 15.4974 4.54183 15.4974 5.00016V8.75016L18.8307 5.41683V14.5835L15.4974 11.2502V15.0002C15.4974 15.4585 15.3342 15.8509 15.0078 16.1772C14.6814 16.5036 14.2891 16.6668 13.8307 16.6668H3.83073ZM3.83073 15.0002H13.8307V5.00016H3.83073V15.0002Z",
    fill: "#667085"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeleconsultationChats);
export default __webpack_public_path__ + "static/media/teleconsultation-chats.684cd2328d95037ff061927ffb525b39.svg";
export { ForwardRef as ReactComponent };